import _ from '../../core/utils'

const MODAL_CONFIG = {
    openers: _.selectAll( '.fl__modal-opener' ),
    closers: _.selectAll( '.fl__modal-closer' )
}

export default MODAL_CONFIG